export const permissionSettings = {
  SUBMITTED: 'permissionSettings.submitted'
}
